export const defaultAsyncRouter = [
  {
    path: '/',
    name: '首页',
    component: 'MenuView',
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: '系统主页',
        icon: 'home',
        component: 'HomePageView',
        meta: { closeable: false },
      },
    ],
  },
]

export function cloneDefaultRouter() {
  return JSON.parse(JSON.stringify(defaultAsyncRouter))
}

export function normalizeRouters(res) {
  const body = res && res.data
  let routers = []
  if (Array.isArray(body)) {
    routers = body
  } else if (body && Array.isArray(body.data)) {
    routers = body.data
  } else if (body && Array.isArray(body.rows)) {
    routers = body.rows
  }
  if (!routers.length) {
    return cloneDefaultRouter()
  }
  return ensureHomePage(routers)
}

export function ensureHomePage(routers) {
  const list = Array.isArray(routers) ? routers : []
  let root = list.find((item) => item.path === '/')
  if (!root) {
    root = cloneDefaultRouter()[0]
    list.unshift(root)
  }
  root.component = root.component || 'MenuView'
  root.children = root.children || []
  const hasHome = root.children.some(
    (item) => item.path === '/home' || item.component === 'HomePageView'
  )
  if (!hasHome) {
    root.children.unshift({
      path: '/home',
      name: '系统主页',
      icon: 'home',
      component: 'HomePageView',
      meta: { closeable: false },
    })
  }
  if (!root.redirect) {
    root.redirect = '/home'
  }
  return list
}
